"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// tslint:disable:deprecation
var React = require("react");
var TabStyles_1 = require("../styles/TabStyles");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var Typography = TabStyles_1.TabStyles.Typography;
var getStyle = function (disabled) { return ({
    fontSize: Typography.Sizing.Default,
    fontWeight: 'normal',
    color: disabled ? Typography.Color.Disabled : Typography.Color.Primary,
    lineHeight: 'normal',
    cursor: 'default'
}); };
var labelMouseDownHandler = function (e) {
    if (!(e.target instanceof HTMLInputElement)) {
        e.preventDefault();
    }
};
var InputLabelWidget = /** @class */ (function (_super) {
    tslib_1.__extends(InputLabelWidget, _super);
    /** @deprecated this is not a very useful Widget. Please contact #dev-shared-widgets if you have a use case. */
    function InputLabelWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputLabelWidget.prototype.render = function () {
        return (React.createElement("label", { className: this.props.className, "data-tb-test-id": this.props.testId + '-Label', id: this.props.id, style: tslib_1.__assign(tslib_1.__assign({}, getStyle(this.props.disabled)), this.props.style), onMouseDown: labelMouseDownHandler }, this.props.children));
    };
    InputLabelWidget = tslib_1.__decorate([
        InteractiveDom_1.InteractiveDomHoCDecorator
        /** @deprecated this is not a very useful Widget. Please contact #dev-shared-widgets if you have a use case. */
    ], InputLabelWidget);
    return InputLabelWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.InputLabelWidget = InputLabelWidget;
//# sourceMappingURL=InputLabelWidget.js.map